var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: "编辑", visible: _vm.dialogVisible, width: "600px" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            size: "small",
            "label-width": "170px",
            rules: _vm.formRule,
            model: _vm.formdata,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品规格编码", prop: "skuId" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入商品规格编码",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.formdata.skuId,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formdata,
                      "skuId",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formdata.skuId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "下单数量", prop: "num" } },
            [
              _c("el-input-number", {
                staticClass: "selWidth",
                attrs: { min: 1, size: "small", clearable: "" },
                model: {
                  value: _vm.formdata.num,
                  callback: function ($$v) {
                    _vm.$set(_vm.formdata, "num", $$v)
                  },
                  expression: "formdata.num",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "收件人姓名", prop: "recipientName" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入收件人姓名",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.formdata.recipientName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formdata,
                      "recipientName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formdata.recipientName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "收件人手机号", prop: "recipientPhone" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入收件人手机号",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.formdata.recipientPhone,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formdata,
                      "recipientPhone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formdata.recipientPhone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "收件人地址-省", prop: "recipientProvince" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入收件人地址-省",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.formdata.recipientProvince,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formdata,
                      "recipientProvince",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formdata.recipientProvince",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "收件人地址-市", prop: "recipientCity" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入收件人地址-市",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.formdata.recipientCity,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formdata,
                      "recipientCity",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formdata.recipientCity",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "收件人地址-区", prop: "recipientArea" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入收件人地址-区",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.formdata.recipientArea,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formdata,
                      "recipientArea",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formdata.recipientArea",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "收件人地址-街道", prop: "recipientStreet" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入收件人地址-街道",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.formdata.recipientStreet,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formdata,
                      "recipientStreet",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formdata.recipientStreet",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: { label: "收件人地址-详细地址", prop: "recipientAddress" },
            },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入收件人地址-详细地址",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.formdata.recipientAddress,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formdata,
                      "recipientAddress",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formdata.recipientAddress",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("确 定")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }